/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageSlot/view.blocks to change it.
import Edit from './Edit/index'
import ImageAction from './ImageAction/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ImageSlot({
  children,
  viewPath = "/DesignSystem/CaptureImageSeries/Content/Active/Content/Images/ImageSlot"
  
}) {
  return (<React.Fragment
>
<ImageAction
  viewPath={`${viewPath}/ImageAction`}
/>
<Edit
  viewPath={`${viewPath}/Edit`}
/>
{children}
</React.Fragment>)
}